<div data-testid="analysis-gaps">
  <app-coverage-tab-header
    titleKey="project.steps.rfi.invitationList.analysis.gapsTitle"
    subtitleKey="project.steps.rfi.invitationList.analysis.gapsSubtitle"
  >
    <p-button
      [label]="'project.steps.rfi.invitationList.analysis.toMatrix' | transloco"
      severity="secondary"
      size="small"
      (onClick)="tabRequested.emit('matrix')"
    />
  </app-coverage-tab-header>

  <div class="bg-second-level overflow-auto rounded-md p-4">
    <table class="ca-table">
      <app-coverage-table-head [columns]="columns" />
      <tbody>
        @for (gap of view().gaps; track $index) {
          <tr data-testid="analysis-gap-row">
            <td>{{ gap.functionName }} ({{ gap.weightShare | appNumber: '1.2-2' }} %)</td>
            <td>{{ gap.countryName }}</td>
            <td>{{ gap.employees | appNumber: '1.0-0' }}</td>
            <td>{{ gap.causeKey | transloco }}</td>
            <td class="text-red text-right tabular-nums">
              −{{ gap.impact | appNumber: '1.2-2' }}
              {{ 'project.steps.rfi.invitationList.analysis.percentagePoints' | transloco }}
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5" class="text-green">
              ✓ {{ 'project.steps.rfi.invitationList.analysis.noDeviations' | transloco }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
